// Employment application options — must match backend choices in server.py.

export const WORK_INTERESTS = [
  "Estate Sale Event Staff / Customer Service",
  "Crowd Control / Customer Direction",
  "Furniture Moving",
  "Loading / Unloading",
  "Estate Cleanouts",
  "Setup / Breakdown",
  "Donation / Removal Work",
  "General Labor",
  "Post-Sale Property Clearing",
  "Other",
];

export const EXPERIENCE_OPTIONS = [
  "Customer Service",
  "Retail",
  "Events",
  "Crowd Control / Security",
  "Estate Sales",
  "Furniture Moving",
  "Loading / Unloading",
  "Cleanouts / Junk Removal",
  "Warehouse Work",
  "Moving Company Experience",
  "Construction",
  "Maintenance",
  "Landscaping / Outdoor Labor",
  "Hospitality",
  "Delivery Work",
  "Using Dollies / Hand Trucks",
  "Using Moving Straps",
  "Power Tools / Hand Tools",
  "Supervising or Leading a Crew",
  "Cash Register / POS Experience",
  "Other",
];

export const AVAILABILITY_OPTIONS = ["Weekdays", "Weekends", "Mornings", "Afternoons", "Evenings", "Short notice / on-call"];

export const TRAVEL_OPTIONS = ["Up to 15 miles", "Up to 30 miles", "Up to 50 miles", "More than 50 miles", "Depends on the assignment"];

export const TRANSPORT_OPTIONS = ["Yes", "No", "Depends on location"];

export const PHYSICAL_OPTIONS = ["Yes", "No", "Depends on the assignment"];

export const APPLICATION_STATUSES = [
  "New",
  "Review",
  "Interview Requested",
  "Interview Scheduled",
  "Awesome Sauce / Strong Candidate",
  "Background Check Pending",
  "Background Check Cleared",
  "Approved On-Call Pool",
  "Assignment Offered",
  "Active",
  "Not Selected",
  "Inactive",
];

// Filter shortcuts for the Approved On-Call Pool view (match against work interests)
export const POOL_WORK_FILTERS = [
  "Estate Sale Event Staff / Customer Service",
  "Crowd Control / Customer Direction",
  "Furniture Moving",
  "Estate Cleanouts",
  "Loading / Unloading",
  "General Labor",
];

export const SUCCESS_MESSAGE =
  "Thanks for your interest in working with MacWay! We received your application. If your availability and experience match an upcoming assignment, we may contact you for a quick phone interview.";

export const BACKGROUND_ACK_TEXT =
  "I understand that if I am selected for certain MacWay Estate Services assignments, I may be required to complete a background screening. Any required disclosure and authorization will be provided separately before a screening is conducted.";

export const CERTIFICATION_TEXT =
  "I certify that the information I provided is accurate to the best of my knowledge. I understand that submitting this application does not guarantee work, placement in the on-call worker pool, or any minimum number of assignments or hours.";
